import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { addToPathList, removePathAndAllSubpaths } from './dialogStepsSliceService'

export interface ExpandedStepsState {
  expandedSteps: string[]
}

export const initialState: ExpandedStepsState = {
  expandedSteps: []
}

export const slice = createSlice({
  name: 'dialogSteps',
  initialState,
  reducers: {
    addExpandedDialog: (state, { payload }: PayloadAction<string>) => {
      state.expandedSteps = addToPathList(state.expandedSteps, payload)
    },
    removeExpandedDialog: (state, { payload }: PayloadAction<string>) => {
      state.expandedSteps = removePathAndAllSubpaths(state.expandedSteps, payload)
    },
    toggleDialog: (state, { payload }: PayloadAction<string>) => {
      if (state.expandedSteps.includes(payload)) {
        state.expandedSteps = removePathAndAllSubpaths(state.expandedSteps, payload)
      } else {
        state.expandedSteps = addToPathList(state.expandedSteps, payload)
      }
    },
    setExpandedDialogs: (state, { payload }: PayloadAction<string[]>) => {
      state.expandedSteps = payload
    },
    resetExpandedDialogs: state => {
      state.expandedSteps = []
    }
  }
})

export const reducer = slice.reducer
export const actions = slice.actions
